module.exports = __webpack_public_path__ + "static/media/EtherealBlade.8b1d73e6.png";